import React from "react";

export function SectionLabel({ number, children, testId }) {
  return (
    <div className="section-label" data-testid={testId || `section-label-${number || "detail"}`}>
      {number && <span className="section-label-number">{number}</span>}
      <span>{children}</span>
    </div>
  );
}
